import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { KTSVG } from '../../../../_metronic/helpers'
import { useIntl } from 'react-intl'
import { EditCaptableModal } from './EditCaptableModal'
import { useAuth } from '../../auth'
import { getCaptableData, updateCaptable } from '../core/_requests'
import { toast } from 'react-toastify'

const CaptableManagementCard = ({
  icon,
  stat,
  title,
  isAuthorized,
  getOverview,
}: {
  icon: string
  stat: any
  title: string
  isAuthorized?: boolean
  getOverview?: any
}) => {
  const { companyId } = useAuth()
  const { formatMessage } = useIntl()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [inputText, setInputText] = useState<number>(0)
  const updateCaptableManagement = async () => {
    setIsLoading(true)
    try {
      const payload: any = {}
      if (title === 'Authorized Capital') {
        payload.authorizedCaptable = +inputText
      } else if (title === 'Authorized Shares') {
        payload.authorizedShares = +inputText
      }
      const {
        data: { success },
      } = await updateCaptable(companyId!, payload)
      if (success) {
        toast.success(formatMessage({ id: 'Successfully updated' }))
        if (getOverview) {
          getOverview()
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
      setIsModalOpen(false)
    }
  }

  const getCaptableManagement = async () => {
    try {
      const {
        data: { success, data },
      } = await getCaptableData(companyId!)
      if (success) {
        if (data.title === 'Authorized Capital') {
          setInputText(data.authorizedCaptable || '')
        } else if (title === 'Authorized Shares') {
          setInputText(data.authorizedShares || '')
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getCaptableManagement()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Card className='w-48 w-md-100 p-4 bg-white'>
        <div className='d-flex align-items-center'>
          <div>
            <KTSVG path={icon} className='icon-size' />
          </div>
          <div
            className='d-flex overflow-auto pt-3 pb-2 ps-1 no-scrollbar'
            style={{ whiteSpace: 'nowrap' }}
          >
            <p className='font-size-24 font-weight-600 mb-0'>{stat}</p>
          </div>
          {isAuthorized && (
            <div className='ms-auto cursor-pointer' onClick={() => setIsModalOpen(true)}>
              <KTSVG path={`/media/icons/captable-management/ic-edit.svg`} className='icon-size' />
            </div>
          )}
        </div>
        <div>
          <p className='font-size-14 text-muted mb-0'>{formatMessage({ id: title })}</p>
        </div>
      </Card>
      <EditCaptableModal
        modalOpen={isModalOpen}
        setModalOpen={setIsModalOpen}
        updateCaptable={updateCaptableManagement}
        isLoading={isLoading}
        title={title}
        inputText={inputText}
        setInputText={setInputText}
      />
    </>
  )
}

export default CaptableManagementCard
